export default __webpack_public_path__ + "0b83c9868f974b8a540b955052a94e36.png";